import { buildRecipe } from "./buildRecipe";
import { MINIMAL_PREMIUM_VOICE } from "./minimalPremiumVoice";
import { SOUND_EVENT_IDS } from "@/audio/core/types";
import type { SoundEventId, SynthLayer } from "@/audio/core/types";

/**
 * The accepted C-BASE baseline: every one of the 44 required events,
 * synthesized through the approved `MINIMAL_PREMIUM_VOICE`. This is the
 * production default for every event not overridden by one of the six
 * locked candidates in `lockedCandidates.ts` - see `finalMapping.ts`.
 */
export const C_BASE_RECIPES: Readonly<Record<SoundEventId, SynthLayer>> = Object.fromEntries(
  SOUND_EVENT_IDS.map((eventId) => [eventId, buildRecipe(eventId, MINIMAL_PREMIUM_VOICE)]),
) as Readonly<Record<SoundEventId, SynthLayer>>;
